import Carousel from 'react-bootstrap/Carousel';
import carrouselPais from '../../assets/aba/CarrosuelInicioPais.png'
import carrouselPeregrino from '../../assets/aba/peregrinoVariedades.png'
import carrouselFabrica from '../../assets/aba/fabricaCarrouselInicio.png'
import carrouselAtonito from '../../assets/aba/atonito.jpg'
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
 //

const texts = {
  textShadow:
  '1px 1px 2px black, 0 0 1em blue, 0 0 0.2em black',
  color: 'white'
}

//

function CarouselInicio() {

  const { i18n, t } = useTranslation();

  return (
    <Carousel fade>
      <Carousel.Item>
        <Link to='/Pais'>
          <img
            src={carrouselPais}
            width="100%"
            height="100%"
            className="d-inline-block align-top"
            alt="Pais"
          />
          <Carousel.Caption>
            <h3 style={texts}>{t('paisCarrousel1')}</h3> 
            <p style={texts}>{t('paisCarrousel2')}</p>
          </Carousel.Caption>
        </Link>
      </Carousel.Item>
      <Carousel.Item>
      <Link to='/Peregrino'>
        <img
            src={carrouselPeregrino}
            width="100%"
            height="100%"
            className="d-inline-block align-top"
            alt="Peregrino"
          />
          <Carousel.Caption>
            <h3 style={texts}>{t('peregrinoCarrousel1')}</h3>  
            <p style={texts}>{t('peregrinoCarrousel2')}</p>
          </Carousel.Caption>
        </Link>
      </Carousel.Item>
      <Carousel.Item>
        <Link to='/Atonito'>
          <img
              src={carrouselAtonito}
              width="100%"
              height="100%"
              className="d-inline-block align-top"
              alt="Peregrino"
            />
          <Carousel.Caption>
            <h3 style={texts}>{t('atonitoCarrousel1')}</h3>
            <p style={texts}>{t('atonitoCarrousel2')}</p>
          </Carousel.Caption>
        </Link>
      </Carousel.Item>
      <Carousel.Item>
      <Link to='/history'>
        <img
            src={carrouselFabrica}
            width="100%"
            height="100%"
            className="d-inline-block align-top"
            alt="Aba logo"
          />
          <Carousel.Caption>
            <h3 style={texts}>{t('factoryCarrousel1')}</h3>
            <p style={texts}>
              {t('factoryCarrousel2')}
            </p>
          </Carousel.Caption>
      </Link>
      </Carousel.Item>
    </Carousel>
  );
}

export default CarouselInicio;